import { Component } from '@angular/core';

@Component({
  selector: 'app-forbidden-component',
  imports: [],
  templateUrl: './forbidden-component.html'
})
export class ForbiddenComponent {

}
